import * as React from 'react';
import { observer } from 'mobx-react';
import * as d3 from 'd3';
import { ISvgAxisProps } from './ISvgAxisProps';

@observer
export class SvgAxis extends React.Component<ISvgAxisProps> {
  private axisElement: SVGElement;

  constructor(props: ISvgAxisProps) {
    super(props, undefined);
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    // https://medium.com/@caspg/responsive-chart-with-react-and-d3v4-afd717e57583
    var axis: d3.svg.Axis;
    if (this.props.orient === 'bottom') {
      axis = d3.svg
        .axis()
        .orient(this.props.orient)
        .scale(this.props.scale)
        .tickSize(-this.props.tickSize)
        .tickPadding(12)
        .tickFormat(x => {
          return x.substr(0, x.indexOf(';'));
        })
        .ticks([4]);
      d3.select(this.axisElement).call(axis);
    } else {
      axis = d3.svg
        .axis()
        .orient(this.props.orient)
        .scale(this.props.scale)
        .tickSize(-this.props.tickSize)
        .tickPadding(49)
        .ticks([8]);
      d3.select(this.axisElement).call(axis);
    }
  }

  render() {
    return (
      <g
        className={`Axis Axis-${this.props.orient} SvgAxis`}
        ref={(el: SVGAElement) => {
          this.axisElement = el;
        }}
        transform={this.props.translate}
      />
    );
  }
}
